// assets/theme/base/colorsDark.js
/**
 * Dark mode colors for Soft UI Dashboard PRO React
 */

const colorsDark = {
  background: {
    default: "#060C18",
    paper: "#060C18",
  },

  text: {
    main: "#a0aec0",
    focus: "#cbd5e1",
  },

  transparent: {
    main: "rgba(0,0,0,0)",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#2d2d3f",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#cb0c9f",
    focus: "#ad0a87",
  },

  secondary: {
    main: "#8392ab",
    focus: "#96a2b8",
  },

  info: {
    main: "#17c1e8",
    focus: "#3acaeb",
  },

  success: {
    main: "#82d616",
    focus: "#95dc39",
  },

  warning: {
    main: "#fbcf33",
    focus: "#fcd652",
  },

  error: {
    main: "#ea0606",
    focus: "#c70505",
  },

  light: {
    main: "#2d2d3f",
    focus: "#3d3d4f",
  },

  dark: {
    main: "#e2e8f0",
    focus: "#ffffff",
  },
  
  green: {
    main: "#009688",
    focus: "#00DFC1"
  },
  
  blue: {
    main: "#0077b5",
    dark: "#344e86",
  },
  
  green2: {
    main: "#009c77",
    focus: "#8fe3cf"
  },
  
  teal: {
    main: "#219297",
    focus: "#219297"
  },

  grey: {
    100: "#1a1a2e",
    200: "#2d2d3f",
    300: "#3d3d4f",
    400: "#4d4d5f",
    500: "#6c757d",
    600: "#8a8a9a",
    700: "#a0aec0",
    800: "#cbd5e1",
    900: "#e2e8f0",
  },

  gradients: {
    primary: {
      main: "#7928ca",
      state: "#ff0080",
    },

    secondary: {
      main: "#627594",
      state: "#a8b8d8",
    },

    info: {
      main: "#2152ff",
      state: "#21d4fd",
    },

    success: {
      main: "#17ad37",
      state: "#98ec2d",
    },

    warning: {
      main: "#f53939",
      state: "#fbcf33",
    },

    error: {
      main: "#ea0606",
      state: "#ff667c",
    },

    light: {
      main: "#4a5568",
      state: "#718096",
    },

    dark: {
      main: "#cbd5e1",
      state: "#e2e8f0",
    },
    
    green: {
      main: "#009688",
      focus: "#00DFC1"
    },
    
    teal: {
      main: "#219297",
      focus: "#219297"
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },
    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },
    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },
    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },
    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },
    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },
    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },
    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },
    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },
    github: {
      main: "#24292e",
      dark: "#171a1d",
    },
    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },
    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  alertColors: {
    primary: {
      main: "#7928ca",
      state: "#d6006c",
      border: "#efb6e2",
    },
    secondary: {
      main: "#627594",
      state: "#8ca1cb",
      border: "#dadee6",
    },
    info: {
      main: "#2152ff",
      state: "#02c6f3",
      border: "#b9ecf8",
    },
    success: {
      main: "#17ad37",
      state: "#84dc14",
      border: "#daf3b9",
    },
    warning: {
      main: "#f53939",
      state: "#fac60b",
      border: "#fef1c2",
    },
    error: {
      main: "#ea0606",
      state: "#ff3d59",
      border: "#f9b4b4",
    },
    light: {
      main: "#4a5568",
      state: "#718096",
      border: "#2d2d3f",
    },
    dark: {
      main: "#cbd5e1",
      state: "#e2e8f0",
      border: "#4a5568",
    },
  },

  badgeColors: {
    primary: {
      background: "#f883dd",
      text: "#a3017e",
    },
    secondary: {
      background: "#e4e8ed",
      text: "#5974a2",
    },
    info: {
      background: "#abe9f7",
      text: "#08a1c4",
    },
    success: {
      background: "#cdf59b",
      text: "#67b108",
    },
    warning: {
      background: "#fef5d3",
      text: "#fbc400",
    },
    error: {
      background: "#fc9797",
      text: "#bd0000",
    },
    light: {
      background: "#4a5568",
      text: "#e2e8f0",
    },
    dark: {
      background: "#718096",
      text: "#1a1a2e",
    },
  },

  inputColors: {
    borderColor: { main: "#4a5568", focus: "#35d1f5" },
    boxShadow: "#81e3f9",
    error: "#fd5c70",
    success: "#66d432",
  },

  sliderColors: {
    thumb: { borderColor: "#4a5568" },
  },

  circleSliderColors: {
    background: "#2d2d3f",
  },

  tabs: {
    indicator: { boxShadow: "#2d2d3f" },
  },
};

export default colorsDark;